import React, { useContext } from 'react';
import { Button, Modal, Toast } from '@/uiComponents/common';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { WelletContext } from '@/context/wellet/welletContext';
import { useParams } from 'react-router-dom';
import { resetPhone } from '@/services';
import { Show } from '@/components';
import { useSelector } from 'react-redux';

const ConfirmDeleteModal = ({ open, onClose, onConfirm }) => {
  const { id } = useParams();
  const organization = useSelector((state) => state.app.selectedOrganization);
  const queryClient = useQueryClient();
  const welletContext = useContext(WelletContext);
  const { t } = useTranslation('translation', {
    keyPrefix: 'screens.profile',
  });

  const handlePhoneResetMutation = useMutation({
    mutationFn: () => {
      const response = resetPhone(welletContext, id);
      return response;
    },
    onSuccess: () => {
      queryClient.setQueryData(['user', id, organization.id], (oldData) => {
        if (!oldData) return oldData;

        const newData = { ...oldData };

        delete newData?.data?.phone;
        return newData;
      });
      onConfirm();
    },
  });

  return (
    <>
      <Modal
        title={t('deletePhoneModal.title')}
        open={open}
        onClose={onClose}
        closeIcon={false}
        maxWidth='450px'
        closeOnDocumentClick={false}
        customButtons={
          <div className='d-flex justify-content-end'>
            <Button
              text={t('deletePhoneModal.cancel')}
              className='btn-general btn-wellet-secondary white'
              size='medium'
              disabled={!handlePhoneResetMutation?.isIdle}
              onClick={onClose}
              type='button'
            />
            <Button
              text={t('deletePhoneModal.confirm')}
              className='ml-2 btn-general btn-wellet-primary'
              size='medium'
              disabled={!handlePhoneResetMutation?.isIdle}
              onClick={() => handlePhoneResetMutation.mutate()}
              type='button'
            />
          </div>
        }
      >
        <div className='tw-text-muted-foreground tw-mt-1'>{t('deletePhoneModal.message')}</div>
      </Modal>
      <Show.When isTrue={handlePhoneResetMutation.isError}>
        <Toast
          message={t('deletePhoneModal.toast.error')}
          type={`ERROR`}
          onCallback={() => {
            handlePhoneResetMutation.reset();
          }}
        />
      </Show.When>
      <Show.When isTrue={handlePhoneResetMutation.isSuccess}>
        <Toast
          message={t('deletePhoneModal.toast.success')}
          type={`SUCCESS`}
          onCallback={() => {
            onClose();
            handlePhoneResetMutation.reset();
          }}
        />
      </Show.When>
    </>
  );
};

export default ConfirmDeleteModal;
